(function () {
  'use strict';

  angular.module('app').component('bookingItemEditPickUpTime', bookingItemEditPickUpTime());

  function bookingItemEditPickUpTime() {
    return {
      bindings: {
        bookingItem: '<',
        booking: '<',
        onBookingItemPickUpTimeSaved: '&',
      },
      controller: BookingItemEditPickUpTimeComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/components/booking-item-edit-pick-up-time/booking-item-edit-pick-up-time.component.html',
    };
  }

  BookingItemEditPickUpTimeComponent.$inject = ['UtilService', '$filter'];

  function BookingItemEditPickUpTimeComponent(UtilService, $filter) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.pickUpTimeError = false;

    vm.$onInit = function () {
      vm.item = angular.copy(vm.bookingItem);

      if (!vm.bookingItem.pickup_time) {
        vm.item.pickup_time = vm.UtilService.setDurationTime(vm.bookingItem.departure_time);
      }
    };

    vm.updateBookingItemPickUpTime = function (pickupTimeSelected) {
      vm.checkPickupTime(vm.item.pickup_time);

      if (vm.pickUpTimeError) return;

      // vm.item.pickup_time = $filter('date')(vm.item.pickup_time, 'HH:mm');

      vm.onBookingItemPickUpTimeSaved({ $bookingItem: vm.item });
    };

    vm.checkPickupTime = function (pickupTimeSelected) {
      if (vm.item.departure_time && vm.item.pickup_time) {
        let departureTime = vm.UtilService.setDurationTime(vm.item.departure_time);
        let pickUpTime = pickupTimeSelected;

        // To avoid seconds
        const dep = moment(departureTime).format('MMM DD, YYYY | hh:mm');
        const pick = moment(pickUpTime).format('MMM DD, YYYY | hh:mm');

        if (dep < pick) {
          vm.pickUpTimeError = true;
        } else {
          vm.pickUpTimeError = false;
        }
        // <=
      }
    };
  }
})();

// console.log(vm.bookingItem.departure_time);

// if (!vm.bookingItem.pickup_time) {
// vm.item.pickup_time = vm.UtilService.setDurationTime(vm.bookingItem.departure_time);
// vm.bookingItem.pickup_time = vm.bookingItem.departure_time;
// vm.bookingItem.pickup_time = $filter('date')(vm.bookingItem.departure_time, 'HH:mm');
// }

// vm.bookingItem.pickup_time = $filter('date')(vm.bookingItem.pickup_time, 'HH:mm');
// vm.bookingItem.pickup_time = vm.UtilService.setDurationTime(vm.bookingItem.pickup_time);

// console.log(vm.bookingItem.pickup_time);

/* let pickup_time = $filter('date')(vm.item.pickup_time, 'HH:mm');
      if (vm.item.departure_time && pickup_time) {
        let departure_date = vm.item.departure_time.split(':');
        pickup_time = pickup_time.split(':');

        if (
          Number(departure_date[0]) <= Number(pickup_time[0]) &&
          Number(departure_date[1]) <= Number(pickup_time[1])
        ) {
          vm.item.pick_up_time_error = true;
          return;
        } else {
          vm.item.pick_up_time_error = false;
        }
      } */

// if (vm.item.departure_time && vm.item.pickup_time) {
//   let departureTime = vm.UtilService.setDurationTime(vm.item.departure_time);
//   let pickUpTime = pickupTimeSelected;

//   if (departureTime < pickUpTime) {
//     vm.pickUpTimeError = true;
//   } else {
//     vm.pickUpTimeError = false;
//   }
// }
